import * as PopoverPrimitive from "@radix-ui/react-popover";
import * as React from "react";
import { cx } from "../internal/cx.js";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;
export const PopoverPortal = PopoverPrimitive.Portal;
export const PopoverClose = PopoverPrimitive.Close;

export interface PopoverContentProps
  extends React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> {
  withArrow?: boolean;
}

export const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  PopoverContentProps
>(function PopoverContent(
  { align = "start", children, className, sideOffset = 8, style, withArrow = false, ...props },
  ref,
) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        className={cx("cw-v2-theme cw-v2-popover__content", className)}
        sideOffset={sideOffset}
        // Inline pointer-events override — see same comment on
        // `SelectContent`. Keeps popovers clickable inside Dialog surfaces.
        style={{ pointerEvents: "auto", ...style }}
        {...props}
      >
        {children}
        {withArrow ? <PopoverPrimitive.Arrow className="cw-v2-popover__arrow" /> : null}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  );
});
PopoverContent.displayName = "PopoverContent";

export const PopoverArrow = React.forwardRef<
  SVGSVGElement,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Arrow>
>(function PopoverArrow({ className, ...props }, ref) {
  return (
    <PopoverPrimitive.Arrow
      ref={ref}
      className={cx("cw-v2-popover__arrow", className)}
      {...props}
    />
  );
});
PopoverArrow.displayName = "PopoverArrow";
